var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drag',[_c('div',{staticClass:"h1-block align-center justify-center"},[_vm._v("H1")])])}
var staticRenderFns = []

export { render, staticRenderFns }